import { LOAD_DATA, REFRESH_DATA, ADD_DATA, EDIT_DATA, EXPORT_DATA, CLEAR_DATA, END_LOAD } from "../actions/types";

const initialState = {
  list: null,
  data: null,
  export: null,
  total: 0,
  page: 0,
  loading: true,
};

export default function data(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_DATA:
      return {
        ...state,
        list: null,
        data: null,
        total: 0,
        page: 0,
        loading: false,
      };

    case REFRESH_DATA:
      return {
        ...state,
        list: payload.data,
        total: payload.total,
        page: payload.page,
        loading: false,
      };
    case EXPORT_DATA:
      return {
        ...state,
        export: payload.data,
        loading: false,
      };
    case LOAD_DATA:
      return {
        ...state,
        data: payload.data,
        loading: false,
      };
    case ADD_DATA:
      return {
        ...state,
        data: payload.data,
        loading: false,
      };
    case EDIT_DATA:
      return {
        ...state,
        data: payload.data,
        loading: false,
      };
    case END_LOAD:
      // console.log("bbbb")
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
